import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { SoundProvider } from './sound/SoundProvider';
import { ReactionProvider } from './reactions/ReactionProvider';
import './styles/app.css';
import { registerServiceWorker } from './services/registerServiceWorker';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SoundProvider><ReactionProvider><App /></ReactionProvider></SoundProvider>
  </StrictMode>
);

registerServiceWorker();
